import React from 'react';
import Home from './Home';

// Preview-only route: clears the session flag (during render, before the intro
// mounts) so the homepage intro always replays here for review.
const IntroPreview = () => {
  try { sessionStorage.removeItem('ktc_intro_seen'); } catch (e) { /* ignore */ }
  return <Home />;
};

export default IntroPreview;
